import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.svg';

const Navigation = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const isActive = (path) => {
        return location.pathname === path ? 'nav-link active' : 'nav-link';
    };

    return (
        <nav className="nav">
            <div className="nav-content">
                <div className="nav-brand">
                    <Link to="/" className={isActive('/')}>
                        <h1 className="nav-title">
                            <img src={logo} alt="AumLaut Logo" width="30" />
                        </h1>
                    </Link>
                </div>
                <div className="nav-links">
                    {user ? (
                        <>
                            <Link to="/dashboard" className={isActive('/dashboard')}>
                                Dashboard
                            </Link>
                            <button onClick={handleLogout} className="button button-danger">
                                Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className={isActive('/login')}>
                                Login
                            </Link>
                            <Link to="/pricing" className="button button-primary">
                                Sign Up
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navigation;